// This is the download link for the excel quiz template.
export const importQuizExcelTemplate = `${window.APP_CONFIG.STATIC_URL}${window.APP_CONFIG.VERSION}/data/socrativeQuizTemplate.xlsx`;
